export const CLEAR_TEMPLATE = "CLEAR_TEMPLATE";
export const GET_TEMPLATE = "GET_TEMPLATE";
export const GET_TEMPLATE_SUCCESS = "GET_TEMPLATE_SUCCESS";



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/withdrawal-configuration/withdrawalEmailTemplateActionTypes.js